// Lucide icon: check (https://lucide.dev/icons/check)
import { Check } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCheck = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Check />
    </IconComponentStyled>
  )
}
